document.addEventListener('DOMContentLoaded', () => {
  showStickyBar();
  window.onscroll = function() {showStickyBar()};
  function showStickyBar() {
    // return false;
    const addToCartForm = document.querySelector(".product-single__form");
    const stickyBar = document.querySelector(".cart-bar");
    if(stickyBar){
      if((document.documentElement.scrollTop - 50) > addToCartForm.offsetTop){
        stickyBar.classList.add("is-visible");
        document.body.classList.add("show-stickybar");
      }else{
        stickyBar.classList.remove("is-visible");
        document.body.classList.remove("show-stickybar");
      }
    }
  }

  document.querySelector(".stickybar-add-to-cart").addEventListener("click", function () {
    let btnSubmit = this;
    btnSubmit.classList.add("btn--loading");
    document.addEventListener("ajaxProduct:added", function () {
      btnSubmit.classList.remove("btn--loading");
    })
  })

  document.querySelector('.product-section').addEventListener('variantPriceChange', function (event) {
    // console.log(event);
    var variant = event.detail.variant;
    const stickyBar = document.querySelector(".cart-bar");
    if (variant) {
      
      var classes = {
        onSale: 'on-sale',
        disabled: 'disabled',
        isModal: 'is-modal',
        loading: 'loading',
        loaded: 'loaded',
        hidden: 'hide',
        interactable: 'video-interactable',
        visuallyHide: 'visually-invisible',
        lowInventory: 'inventory--low',
      };
      const comparePrice = stickyBar.querySelector("[data-compare-price]");
      const priceWrapper = stickyBar.querySelector("[data-product-price-wrap]");
      const price = stickyBar.querySelector("[data-product-price]");
      const comparePriceA11y = stickyBar.querySelector("[data-compare-price-a11y]");
      const priceA11y = stickyBar.querySelector("[data-a11y-price]");
      const savePrice = stickyBar.querySelector("[data-save-price]");

      // Regular price
      price.innerHTML = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);

      // Sale price, if necessary
      if (variant.compare_at_price > variant.price) {
        comparePrice.innerHTML = theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat);
        priceWrapper.classList.remove(classes.hidden);
        price.classList.add(classes.onSale);
        comparePriceA11y.setAttribute('aria-hidden', 'false');
        priceA11y.setAttribute('aria-hidden', 'false');

        var savings = variant.compare_at_price - variant.price;

        if (theme.settings.saveType == 'percent') {
          savings = Math.round(((savings) * 100) / variant.compare_at_price) + '%';
        } else {
          savings = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
        }

        savePrice.classList.remove(classes.hidden);
        savePrice.innerHTML = theme.strings.savePrice.replace('[saved_amount]', savings);
      } else {
        if (priceWrapper) {
          priceWrapper.classList.add(classes.hidden);
        }
        savePrice.classList.add(classes.hidden);
        price.classList.remove(classes.onSale);
        if (comparePriceA11y) {
          comparePriceA11y.setAttribute('aria-hidden', 'true');
        }
        priceA11y.setAttribute('aria-hidden', 'true');
      }
    }
  })

  document.addEventListener('variant:change', function (event) {
    let stickyButton = document.querySelector(".stickybar-add-to-cart");
    if(stickyButton){
      if(event.detail.variant.available){
        stickyButton.removeAttribute('disabled');
        stickyButton.querySelector("span").innerHTML = stickyButton.getAttribute("data-add-to-cart-text");
      }else{
        stickyButton.setAttribute('disabled', 'disabled');
        stickyButton.querySelector("span").innerHTML = stickyButton.getAttribute("data-sold-out-text");
      }
    }
  })

})